import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace/product-models")({
  beforeLoad: () => {
    throw redirect({ to: "/system/data-catalog/product-models" });
  },
});
